import { render, staticRenderFns } from "./PFSettlementForm.vue?vue&type=template&id=f7fead62&scoped=true"
import script from "./PFSettlementForm.vue?vue&type=script&lang=js"
export * from "./PFSettlementForm.vue?vue&type=script&lang=js"
import style0 from "./PFSettlementForm.vue?vue&type=style&index=0&id=f7fead62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7fead62",
  null
  
)

export default component.exports